import { useMemo } from "react";
import { useApiQuery, useApiMutation } from "../services/react-query.js";

export const useGetAllFeatureFlags = ({ eventId }) => {
  // Callers pass either the number from the user config or the string from the
  // URL params; normalize so both share one cache entry.
  const id = eventId ? Number(eventId) : eventId;

  return useApiQuery({
    queryOptions: {
      queryKey: ["featureFlags", id],
    },
    fetchOptions: {
      url: "/feature-flags",
      method: "GET",
      params: { eventId: id },
    },
  });
};

export const useUpdateFeatureFlag = (flagId) => {
  return useApiMutation({
    mutationOptions: {
      mutationKey: ["updateFeatureFlag", flagId],
    },
    fetchOptions: {
      url: `/feature-flags/${flagId}`,
      method: "PATCH",
    },
    invalidateQueryKeys: [["featureFlags"]],
    successMessage: {
      title: "Feature flag was updated successfully",
    },
  });
};

/**
 * Returns whether a specific feature flag is enabled for the given event.
 * Uses the cached feature flags query — no extra network request.
 */
export const useIsFeatureEnabled = (eventId, featureName) => {
  const { data: flags } = useGetAllFeatureFlags({ eventId });

  return useMemo(() => {
    if (!flags || !Array.isArray(flags)) return false;
    const flag = flags.find((f) => f.featureName === featureName);
    return flag?.enabled ?? false;
  }, [flags, featureName]);
};
